export default __webpack_public_path__ + "81d28cdc676e8e3fdfd6663649704539.png";